import React from "react";
import Projects from "./Projects";
import Experience from "./Experience";
import Education from "./Education";
import Skills from "./Skills";
import Contact from "./Contact";
import { FaLinkedin, FaGithub, FaEnvelope } from "react-icons/fa";

function Home() {
  return (
    <div className="font-sans text-base flex flex-col items-center justify-center min-h-screen py-6 px-2 sm:px-4 md:px-8 bg-transparent transition-colors duration-300">
      {/* About Section */}
      <section
        id="about"
        className="w-full max-w-5xl flex flex-col md:flex-row items-start justify-between mb-4"
      >
        {/* Left Side - Text content */}
        <div className="flex flex-col flex-1 items-start justify-start pr-6">
          <h1
            className="mb-2 text-3xl font-extrabold text-[#213448] md:text-4xl dark:text-slate-100"
          >
            Siddhant Kumar
          </h1>
          <h2 className="mb-3 text-base text-neutral-700 dark:text-slate-300 md:text-lg">
            Software Engineer | Full Stack Developer
          </h2>
          <div className="flex flex-row items-center space-x-4 mb-3 flex-wrap">
            <a
              href="https://www.linkedin.com/in/siddhantkumar052/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#547792] transition hover:text-orange-500 dark:text-[#b8d5e6] dark:hover:text-[#F59E0B]"
              aria-label="LinkedIn"
            >
              <FaLinkedin size={22} />
            </a>
            <a
              href="https://github.com/siddhantkumar052"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#547792] transition hover:text-orange-500 dark:text-[#b8d5e6] dark:hover:text-[#F59E0B]"
              aria-label="GitHub"
            >
              <FaGithub size={22} />
            </a>
            <a
              href="mailto:siddhantkumar052@gmail.com"
              className="text-[#547792] transition hover:text-orange-500 dark:text-[#b8d5e6] dark:hover:text-[#F59E0B]"
              aria-label="Email"
            >
              <FaEnvelope size={22} />
            </a>
          </div>
        </div>

        {/* Right Side - Image */}
        <div className="mt-4 md:mt-0">
          <img
            src={require("../Assets/my-photo.png")}
            alt="Profile"
            className="w-28 h-28 md:w-36 md:h-36 rounded-full object-cover shadow-lg"
          />
        </div>
      </section>

      {/* About Me Section */}
      <section id="aboutme" className="w-full max-w-5xl mb-4">
        <div className="w-full max-w-5xl mx-auto">
          <h2 className="text-2xl font-extrabold text-[#213448] dark:text-slate-100">
            About
          </h2>
          <div className="mb-4 h-1 w-16 rounded bg-[#94B4C1] dark:bg-[#94B4C1]"></div>
          <p className="mb-4 text-gray-700 dark:text-slate-300">
            Hello! I'm Siddhant, a full stack developer with a passion for
            building cool projects and diving into new technologies. From side
            apps to scalable platforms, I've explored a wide range of challenges
            that have helped me grow as a developer.
            <br />
            <br />
            On the frontend, I focus on crafting responsive, dynamic interfaces
            with React, Redux, GraphQL, and modern JavaScript. On the backend,
            I've worked with Spring Boot, Node.js, Python, and built APIs that
            run on Linux servers with Apache or deploy seamlessly on AWS.
            <br />
            <br />
            Currently, I'm working at the University of Mississippi, helping
            migrate and manage the campus website using Cascade CMS, PHP,
            JavaScript, Velocity, and SQL, while ensuring strong accessibility
            and performance. Previously at Henry Schein, I developed scalable
            web solutions and implemented CI/CD pipelines on AWS.
            <br />
            <br />
            Right now I'm exploring custom GPT development and preparing for the
            AWS Developer Associate certification. Whether it's improving user
            experience, optimizing code, or experimenting with ML tools, I love
            building things that make a difference.
          </p>
        </div>
      </section>

      {/* Experience Section */}
      <section id="experience" className="w-full max-w-5xl my-6">
        <div className="w-full max-w-5xl mx-auto">
          <h2 className="text-2xl font-extrabold text-[#213448] dark:text-slate-100">
            Experience
          </h2>
          <div className="mb-4 h-1 w-16 rounded bg-[#94B4C1] dark:bg-[#94B4C1]"></div>
          <Experience />
        </div>
      </section>

      {/* Projects Section */}
      <section id="work" className="w-full max-w-5xl my-6">
        <div className="w-full max-w-5xl mx-auto">
          <h2 className="text-2xl font-extrabold text-[#213448] dark:text-slate-100">
            Projects
          </h2>
          <div className="mb-4 h-1 w-16 rounded bg-[#94B4C1] dark:bg-[#94B4C1]"></div>
          <Projects />
        </div>
      </section>

      {/* Skills Section */}
      <section id="skills" className="w-full max-w-5xl my-6">
        <div className="w-full max-w-5xl mx-auto">
          <h2 className="text-2xl font-extrabold text-[#213448] dark:text-slate-100">
            Skills
          </h2>
          <div className="mb-4 h-1 w-16 rounded bg-[#94B4C1] dark:bg-[#94B4C1]"></div>
          <Skills />
        </div>
      </section>

      {/* Education Section */}
      <section id="education" className="w-full max-w-5xl my-6">
        <div className="w-full max-w-5xl mx-auto">
          <h2 className="text-2xl font-extrabold text-[#213448] dark:text-slate-100">
            Education
          </h2>
          <div className="mb-4 h-1 w-16 rounded bg-[#94B4C1] dark:bg-[#94B4C1]"></div>
          <Education />
        </div>
      </section>

      {/* Contact Section */}
      <Contact />
    </div>
  );
}

export default Home;
